import {
  DataTablePrimeReact,
  OptionsMenuStorybook,
  PaginationERP,
} from "@finanedi.es/storybook"
import { faPen } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FacturaReadingSimpleDtoProps } from "api/DTOs/FacturaReadingSimpleDto"
import { FlujoTesoreriaReadingDtoProps } from "api/DTOs/FlujoTesoreriaReadingDto"
import { FlujoTesoreriaReadingFiltersDtoProps } from "api/DTOs/FlujoTesoreriaReadingFiltersDto"
import { getFacturasByIdSimple } from "api/Factura.service"
import {
  getFlujoTesoreriaReadingFiltersDtoIPagedEnumerable,
  getFlujoTesoreriaReadingFiltersDtoIPagedEnumerableParamsProps,
  getFlujoTesoreriaTotalImporte,
  getPagosCobrosById,
} from "api/FlujoTesoreria.service"
import { TIPO_CONCILIACION } from "api/Types/TipoConciliacion"
import { TIPO_DOCUMENTO_ENUM } from "api/Types/TipoDocumentoEnum"
import {
  TIPO_FLUJO_TESORERIA,
  TipoFlujoTesoreriaType,
} from "api/Types/TipoFlujoTesoreria"
import { SortingCriteria } from "api/interfaces/SortingCriteria"
import axios from "axios"
import ActionToast from "common/components/ActionToast"
import DeleteModal from "common/components/Modal/DeleteModal"
import Modal from "common/components/Modal/Modal"
import ModalVerDocumento from "common/components/ModalVerDocumento/ModalVerDocumento"
import { SEARCH_PARAMS } from "common/constants"
import PagosYCobrosService from "common/services/TesoreriaService"
import { getSearchParams, requestHandler } from "common/utils/utils"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import NewPagoForm from "features/Tesoreria/components/NewPagoForm"
import { CURRENT_PAYMENT_TYPE } from "features/Tesoreria/components/NewPagoForm/constants"
import { useDispatch } from "hooks/useDispatch"
import { useFilterMenu } from "hooks/useFilterMenu"
import { Tooltip } from "primereact/tooltip"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import { IconDeletetypes } from "../../../../common/components/Modal/DeleteModal/constants"
import ModalConciliacionMovimientos from "../Bancos/pages/BancosDetail/components/ModalConciliadosMovimientos/ModalConciliadosMovimientos"
import { getIdsFromDocumentos } from "../Cartera/constants"
import { FilterMenu } from "./FilterMenu"
import { PAGOS_COBROS_COLUMNS } from "./PagosCobrosColumns"
import PagosCobrosFooter from "./components/PagosCobrosTable/PagosCobrosFooter"
import PagosCobrosTable from "./components/PagosCobrosTable/PagosCobrosTable"
import { PAYMENT_TYPE_PAGOS_COBROS_ACTION_SETTINGS } from "./constants"
import "./pagosCobros.styles.css"
import "./style.scss"

const PagosCobros = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const location = useLocation()
  const param = getSearchParams(location, SEARCH_PARAMS.GOTO)
  const [documentSelected, setDocumentSelected] = useState<
    Array<FlujoTesoreriaReadingFiltersDtoProps>
  >([])
  const [modalDocumentoDetail, setModalDocumentoDetail] = useState<{
    show: boolean
    document: FacturaReadingSimpleDtoProps | null
  }>({
    show: false,
    document: null,
  })
  const [showCreateModal, setShowCreateModal] = useState<{
    data: FlujoTesoreriaReadingDtoProps | null
    status: boolean
  }>({
    data: null,
    status: false,
  })
  const [showDeleteModal, setShowDeleteModal] = useState<
    typeof showCreateModal
  >({
    data: null,
    status: false,
  })
  const initialDate = [
    new Date(`${new Date().getFullYear()}-01-01`),
    new Date(),
  ]
  const [dates, setDates] = useState<Date[] | undefined>(initialDate)
  const [importePendiente, setImportePendiente] = useState(0)
  const [sortingCriteria, setSortingCriteria] = useState<SortingCriteria>({
    sort: undefined,
    property: undefined,
  })
  const [pagination, setPagination] = useState({
    itemsPerPage: 100,
    skipCount: 0,
  })

  const [sortField, setSortField] = useState<string | undefined>(undefined)
  const [sortOrder, setSortOrder] = useState<1 | 0 | -1 | null | undefined>(0)
  const dtRef = useRef<DataTablePrimeReact<
    FlujoTesoreriaReadingFiltersDtoProps[]
  > | null>(null)
  const handleResetPagination = () => {
    dtRef.current && dtRef.current?.resetScroll()
    setPagination({
      itemsPerPage: pagination.itemsPerPage,
      skipCount: 0,
    })
  }
  const onSort = ({
    sortField,
    sortOrder,
  }: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => {
    setSortingCriteria({
      property: sortField ?? undefined,
      sort: sortOrder === 1 ? "ASC" : sortOrder === -1 ? "DESC" : undefined,
    })
    setSortField(sortField)
    setSortOrder(sortOrder)
    handleResetPagination()
  }

  const resetScroll = () => {
    const element = document.querySelector(".ant-table-container")
    if (element) {
      element.scrollTop = 0
      element.scrollLeft = 0
    }
  }

  const totalImporteCancelToken = useRef(axios.CancelToken.source())
  const tesoreriaCancelToken = useRef(axios.CancelToken.source())
  const fetchPagosYCobros = useCallback(
    () =>
      (
        queryParams: getFlujoTesoreriaReadingFiltersDtoIPagedEnumerableParamsProps
      ) => {
        totalImporteCancelToken.current?.cancel()
        totalImporteCancelToken.current = axios.CancelToken.source()
        tesoreriaCancelToken.current?.cancel()
        tesoreriaCancelToken.current = axios.CancelToken.source()
        getFlujoTesoreriaTotalImporte(
          {
            ...queryParams,
            SkipCount: queryParams.SkipCount ?? 0,
            MaxResultCount:
              queryParams.MaxResultCount ?? pagination.itemsPerPage,
          },
          totalImporteCancelToken.current.token
        ).then((importe) => setImportePendiente(importe))
        return getFlujoTesoreriaReadingFiltersDtoIPagedEnumerable(
          {
            ...queryParams,
            SkipCount: queryParams.SkipCount ?? 0,
            MaxResultCount:
              queryParams.MaxResultCount ?? pagination.itemsPerPage,
            SortingCriteria: queryParams.SortingCriteria,
          },
          tesoreriaCancelToken.current.token
        )
      },
    [pagination.itemsPerPage]
  )
  const { items, isLoading, totalCount, setServiceQuery, fetchTableData } =
    useFilterMenu({
      serviceCall: fetchPagosYCobros,
    })
  const handleHideToast = () => {
    setDocumentSelected([])
  }

  const handleOpenDeleteModal = (
    id: $TSMigrationFixMe,
    tipo: $TSMigrationFixMe
  ) => {
    setShowDeleteModal({
      data: { id, tipo },
      status: !showDeleteModal.status,
    })
  }

  const handleOpenCreateModal = useCallback(
    (_: $TSMigrationFixMe, openModal: $TSMigrationFixMe) => {
      setShowCreateModal({ data: null, status: openModal })
    },
    []
  )

  const onSuccessCreate = () => {
    handleOpenCreateModal(null, false)
    fetchTableData()
  }

  const onSuccessDelete = () => {
    fetchTableData()
  }

  const onPostDelete = () => {
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    handleOpenDeleteModal({
      data: null,
      status: false,
    })
    handleHideToast()
    handleOpenCreateModal(null, false)
  }

  const handleCreate = async (
    key: TipoFlujoTesoreriaType,
    values: $TSMigrationFixMe
  ) => {
    requestHandler(
      values,
      PAYMENT_TYPE_PAGOS_COBROS_ACTION_SETTINGS()[key].postService,
      onSuccessCreate,
      `${PAYMENT_TYPE_PAGOS_COBROS_ACTION_SETTINGS()[key].title}${t(
        "pagoCobro.msg.createExit"
      )}`,
      null,
      null,
      null
    )
  }

  const handleEdit = async (values: $TSMigrationFixMe) => {
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'null'.
    const { id, tipoRemesable } = showCreateModal.data
    requestHandler(
      { data: values, id },
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      PAYMENT_TYPE_PAGOS_COBROS_ACTION_SETTINGS(t)[showCreateModal.data.tipo][
        tipoRemesable === 0 ? "putService" : "putRemesableService"
      ],
      onSuccessCreate,
      `${
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        PAYMENT_TYPE_PAGOS_COBROS_ACTION_SETTINGS(t)[showCreateModal.data.tipo]
          .title
      }${t("pagoCobro.msg.editExit")}`,
      null,
      null,
      null
    )
  }

  const handleBulkDelete = async () => {
    const documentsToDelete = getIdsFromDocumentos(documentSelected)
    requestHandler(
      documentsToDelete,
      PagosYCobrosService.deletePagosYCobros,
      onSuccessDelete,
      `${t("pagoCobros.msg.flowExit")}`,
      null,
      null,
      onPostDelete
    )
  }

  const handleDelete = async () => {
    requestHandler(
      showDeleteModal.data?.id,
      // @ts-expect-error TS(2339): Property 'tipo' does not exist on type 'never'.
      PAYMENT_TYPE_PAGOS_COBROS_ACTION_SETTINGS(t)[showDeleteModal.data?.tipo]
        .deleteService,
      onSuccessDelete,
      `${t("pagoCobro.msg.flowExit")}`,
      null,
      null,
      onPostDelete
    )
  }

  const onRenderContent = useMemo(() => {
    return (
      <div className='tw-flex tw-justify-center md:tw-justify-start'>
        <span className='tw-font-medium'>
          {t("pagoCobro.modal.labelSelected")} {documentSelected?.length}
        </span>
      </div>
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentSelected?.length])

  const handleOpenDocumentoModal = async (id: string) => {
    const facturaById = await getFacturasByIdSimple(id)
    setModalDocumentoDetail({
      show: true,
      document: facturaById,
    })
  }

  const openCreateDialogByDefault = () => {
    setShowCreateModal({
      ...showCreateModal,
      // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable...
      status: [SEARCH_PARAMS.COBRO, SEARCH_PARAMS.PAGO].includes(param),
    })
  }

  useEffect(() => {
    openCreateDialogByDefault()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param])

  useEffect(() => {
    resetScroll()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination])

  const [showModalConciliacion, setShowModalConciliacion] = useState<{
    show: boolean
    data: FlujoTesoreriaReadingFiltersDtoProps | undefined
  }>({
    show: false,
    data: undefined,
  })

  const onHideModalConciliacion = () => {
    setShowModalConciliacion({
      show: false,
      data: showModalConciliacion.data,
    })
  }

  const fetchOperationById = (id: string) => {
    getPagosCobrosById(id).then((data) => {
      setShowCreateModal({
        data: { ...data },
        status: true,
      })
    })
  }

  const handleEditModal = (
    rowData: FlujoTesoreriaReadingFiltersDtoProps,
    openModal: boolean
  ) => {
    if (openModal) {
      rowData?.id && fetchOperationById(rowData.id)
    } else {
      setShowCreateModal({ data: null, status: false })
    }
  }

  const onRenderActionIcons = (
    rowData: FlujoTesoreriaReadingFiltersDtoProps
  ) => {
    return (
      <div className='tw-flex tw-justify-end'>
        <OptionsMenuStorybook
          id={rowData.id}
          items={[
            {
              title: `${
                rowData.tipo === TIPO_FLUJO_TESORERIA.COBRO
                  ? t("pagoCobro.editCharge")
                  : t("pagoCobro.editPayment")
              }`,
              hasRedirect: false,
              icon: faPen,
              className: "tw-text-text-50",
              action: () => handleEditModal(rowData, true),
            },
          ]}
          position='right'
        />
      </div>
    )
  }

  const onRenderCoincidenciasMovimientos = (
    props: FlujoTesoreriaReadingFiltersDtoProps
  ) => {
    return (
      <>
        <Tooltip
          target={`.tooltip-info-${props.id}`}
          content={
            props.conciliacion?.tipoConciliacion === TIPO_CONCILIACION.FORZADA
              ? `${t("nsAssets.filters.status.forzosas")}`
              : ""
          }
          position='right'
          className='tooltip-cartera-header tw-ml-2'
        />
        <span
          className={`tooltip-info-${props.id} tw-flex tw-flex-row tw-items-center tw-w-fit`}
        >
          {props.conciliacion?.tipoConciliacion ===
            TIPO_CONCILIACION.FORZADA && (
            <div className='!tw-mr-2 !tw-w-5 !tw-h-5 !tw-flex !tw-p-0 !tw-justify-center !tw-items-center !tw-border !tw-border-text-hyperlinks !tw-text-text-hyperlink !tw-rounded !tw-bg-transparent'>
              F
            </div>
          )}

          <span>
            {props.conciliacion?.id !== null ||
            props.conciliacion?.tipoConciliacion ===
              TIPO_CONCILIACION.FORZADA ? (
              <span
                onClick={() =>
                  setShowModalConciliacion({
                    show: true,
                    data: props,
                  })
                }
                className='tw-cursor-pointer tw-text-info-100 tw-no-underline hover:tw-underline'
              >
                {t("bancos.statusConciliacion.conciled")}
              </span>
            ) : (
              <span className='tw-text-text'>
                {t("bancos.statusConciliacion.notConciled")}
              </span>
            )}
          </span>
        </span>
      </>
    )
  }

  return (
    <section className='tw-flex tw-flex-col tw-order-2 tw-z-10 tw-relative tw-bg-white tw-w-full tw-max-h-screen tw-h-full tw-overflow-x-hidden tw-overflow-y-hidden'>
      <FilterMenu
        maxResultCount={pagination.itemsPerPage}
        resetPagination={handleResetPagination}
        serviceQuery={setServiceQuery}
        skipCount={pagination.skipCount}
        sortingCriteria={sortingCriteria}
        createNew={() => handleOpenCreateModal(null, true)}
        handleDates={{ dates, setDates }}
      />
      <div className='tw-flex tw-flex-col tw-h-[calc(100%-140px)] tw-relative'>
        <div className='tw-h-[calc(100%-60px)] tw-h-min-0'>
          <PagosCobrosTable
            columns={PAGOS_COBROS_COLUMNS(
              t,
              setShowModalConciliacion,
              handleOpenDocumentoModal,
              onRenderActionIcons,
              onRenderCoincidenciasMovimientos
            )}
            refTable={dtRef}
            items={items}
            loading={isLoading}
            onSort={onSort}
            sortField={sortField}
            sortOrder={sortOrder}
            selection={documentSelected}
            onSelectionChange={({
              value,
            }: {
              value: FlujoTesoreriaReadingFiltersDtoProps[]
            }) => {
              setDocumentSelected(value)
            }}
          />
          <PagosCobrosFooter
            t={t}
            importePendiente={importePendiente}
            startDate={dates ? dates[0] : undefined}
            endDate={dates ? dates[1] : undefined}
          />
          <PaginationERP
            className={PAGINATION_STYLES}
            totalRecords={totalCount}
            first={pagination.skipCount}
            rows={pagination.itemsPerPage}
            resetScroll={() => {
              dtRef.current && dtRef.current?.resetScroll()
            }}
            setPagination={setPagination}
            optionDropdown={[10, 20, 50, 100]}
            texts={{
              textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
              textCurrentPageReport: `${t("pagination.from")}`,
            }}
          />
        </div>
      </div>
      <Modal
        header={`${
          showCreateModal?.data?.id
            ? `${t("pagoCobro.modal.headerEdit")} ${(showCreateModal?.data
                ?.tipo === CURRENT_PAYMENT_TYPE.PAGO
                ? t("pagoCobro.modal.labelPayment")
                : t("pagoCobro.modal.labelCollection")
              ).toLowerCase()}`
            : t("pagoCobro.modal.headerNew")
        }`}
        visible={showCreateModal.status}
        onHide={() => handleOpenCreateModal(null, false)}
        size='default'
        className='departaments-modal'
        draggable
        baseZindex={30}
        keepInViewport={false}
      >
        <NewPagoForm
          // @ts-expect-error TS(2322): Type '{ hideModal: () => void; isEditView: boolean...
          hideModal={() => handleOpenCreateModal(null, false)}
          isEditView={Boolean(showCreateModal?.data?.id)}
          dispatch={dispatch}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          handleDelete={handleOpenDeleteModal}
          data={showCreateModal.data}
          t={t}
          hasSwitch
        />
      </Modal>
      <ActionToast
        show={Boolean(documentSelected?.length)}
        onHide={handleHideToast}
        content={onRenderContent}
        customButtons={
          <div
            className='delete-icon_container'
            onClick={() =>
              setShowDeleteModal((prevState) => ({
                ...prevState,
                status: true,
              }))
            }
          >
            <FontAwesomeIcon icon={["fal", "trash-can"]} />

            <span className='tw-pt-0.5'>
              {t("pagoCobro.modal.labelDelete")}
            </span>
          </div>
        }
      />
      <DeleteModal
        visible={showDeleteModal.status}
        onHide={handleOpenDeleteModal}
        size='small'
        iconType={IconDeletetypes.pagos}
        buttonLabel={t("pagoCobro.modal.delete.confirmButton")}
        title={t("pagoCobro.modal.delete.title")}
        message={t("pagoCobro.modal.delete.msg")}
        onConfirm={showDeleteModal.data?.tipo ? handleDelete : handleBulkDelete}
      />
      <ModalVerDocumento
        showModal={modalDocumentoDetail.show}
        onHide={() =>
          setModalDocumentoDetail({
            show: false,
            document: null,
          })
        }
        docType={TIPO_DOCUMENTO_ENUM.FACTURA}
        documentoID={modalDocumentoDetail.document?.id ?? null}
        typeDocumentTable='facturas'
      />
      <ModalConciliacionMovimientos
        data={showModalConciliacion.data}
        showModal={showModalConciliacion.show}
        conciliacionBancariaId={showModalConciliacion.data?.conciliacion?.id}
        onHideModalConciliacion={onHideModalConciliacion}
        fetchTable={fetchTableData}
        i18nModalConfirmDescription={t(
          `pagoCobro.forced.confirmation.${showModalConciliacion.data?.tipo}`
        )}
      />
    </section>
  )
}

export default PagosCobros
